import i18n from "i18next";
import { getIntlLocale } from "./locale";

function parseNumericValue(value) {
  if (typeof value === "number") return value;

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed || trimmed === "-") return Number.NaN;

    const numericCandidate = trimmed.replace(/\s/g, "").replace("%", "");
    if (/^[+-]?\d[\d.,]*$/.test(numericCandidate)) {
      const hasComma = numericCandidate.includes(",");
      const hasDot = numericCandidate.includes(".");

      let normalized = numericCandidate;
      if (hasComma && hasDot) {
        if (numericCandidate.lastIndexOf(",") > numericCandidate.lastIndexOf(".")) {
          normalized = numericCandidate.replace(/\./g, "").replace(",", ".");
        } else {
          normalized = numericCandidate.replace(/,/g, "");
        }
      } else if (hasComma) {
        normalized = numericCandidate.replace(",", ".");
      } else if (hasDot) {
        const dotCount = (numericCandidate.match(/\./g) || []).length;
        if (dotCount > 1) {
          normalized = numericCandidate.replace(/\./g, "");
        } else {
          const parts = numericCandidate.split(".");
          const decimalPart = parts[1] || "";
          if (decimalPart.length === 3 && numericCandidate.length > 4) {
            normalized = numericCandidate.replace(/\./g, "");
          }
        }
      }

      const parsed = parseFloat(normalized);
      if (!Number.isNaN(parsed)) return parsed;
    }
  }

  return Number(value);
}

export function formatNumber(value, options = {}) {
  if (value === "-" || value === null || value === undefined || value === "") {
    return "-";
  }

  const num = parseNumericValue(value);
  if (Number.isNaN(num)) return "-";

  const lang = getIntlLocale(i18n.language);

  const formatter = new Intl.NumberFormat(lang, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    useGrouping: true,
    ...options,
  });

  return formatter.format(num);
}
